import { render } from "./ComfirmButton.vue?vue&type=template&id=507605ba&scoped=true"
import script from "./ComfirmButton.vue?vue&type=script&lang=js"
export * from "./ComfirmButton.vue?vue&type=script&lang=js"

import "./ComfirmButton.vue?vue&type=style&index=0&id=507605ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507605ba"]])

export default __exports__